/**
 * Formats a price in integer cents as a currency string. Renders four
 * decimal places when the unit price has fractional cents (distributors
 * routinely quote $0.0123/unit at deep break tiers); two decimals
 * otherwise. Returns `—` for null so empty cells stay quiet.
 */
export function formatPriceCents(
  cents: number | null | undefined,
  currency: string | null | undefined = 'USD',
): string {
  if (cents === null || cents === undefined) return '—';
  const value = cents / 100;
  // Distributors quote sub-cent tier prices ($0.012/unit at 3000+).
  // Use 4 decimals when below $0.10/unit so the user sees real
  // resolution, two decimals otherwise.
  const fractionDigits = Math.abs(value) < 0.1 ? 4 : 2;
  const formatted = value.toLocaleString(undefined, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
  const c = currency || 'USD';
  return c === 'USD' ? `$${formatted}` : `${formatted} ${c}`;
}
